interface PaginaParcial<T> {
  content?: T[];
  totalElements?: number;
}

/** Percorre uma listagem paginada até o fim (as rotas de catálogo do BFF limitam `size` a 200). */
export async function buscarTodasPaginas<T>(
  buscar: (page: number, size: number) => Promise<{ data: PaginaParcial<T> }>,
  { size = 200, maxPaginas = 50 }: { size?: number; maxPaginas?: number } = {},
): Promise<T[]> {
  const itens: T[] = [];
  for (let page = 0; page < maxPaginas; page++) {
    const { data } = await buscar(page, size);
    const content = data.content ?? [];
    itens.push(...content);
    const total = data.totalElements;
    if (content.length < size || (total !== undefined && itens.length >= total)) break;
  }
  return itens;
}
